import { useState } from "react";
// import StranaPrimeri from "./StranaPrimeri";
import YourmapAppContainer from "./YourmapAppContainer";
import UniLimiter from "./UniLimiter";
import { routing_utils_match_and_extract_params_v3 } from "../utils/frfr-routing-utils";


//
/*
const initialAppState = {
  // freshness: 0,
  freshness: 1,
  url_path: '',
  detected_env: null,
  routeSimple: {
    route: 'ROOT_HOME',
    // title: 'Početna',
    // breadcrumbs: [],
    route_params: {},
    freshness: 0
  },
  ulogovan: false,
  my_user_data: {},
  token: null,

  tables_data: {
    "TABLE_CLIENTS": {
      type_is_arr: true,
      fatching: false,
      
      data: [
        {
          id: 1,
          email: 'e',
        },
        {
          id: 2,
          email: 'ee',
        },
        {
          id: 3,
          email: 'eee',
        }
      ],
      
      data: [],
    },
  },
};
*/

const YourmapTest1 = (props) => {
  /*
  console.log('YourmapTest1 TEST 1...');
  const matching_pack = routing_utils_match_and_extract_params_v3("/istrazi/kopaonik/smestaji/5", "/istrazi/:slug/smestaji/:thing_id");
  console.log('TEST 1 matching_pack', matching_pack);
  */
  return (<></>);
};

//
const AppYourmap = (props) => {
  // const [appState, setAppState] = useState(initialAppState);
  return (
    <>
      {/*
      */}
      <YourmapTest1 />
      <YourmapAppContainer />
      {/*
      <YourmapLayout
        appState={appState}
        setAppState={setAppState}
      />
      <YourmapAdminPanel
        appState={appState}
        setAppState={setAppState}
      />
      */}
      {/*
      <div className="uu-p-30px">
        <UniLimiter w={800}>
          <StranaPrimeri />
        </UniLimiter>
      </div>
    */}
    </>
  );
};

export default AppYourmap;